<div class="auto">
  <div class="auth-wrapper legal_mobile">
  <div class="card service_agreement">
    <!-- Check Icon -->
    <div class="icon-wrapper">
      <div class="check-circle">
        ✓
      </div>
    </div>

    <!-- Title -->
    <h2>Onboarding Complete!</h2>
    <p class="subtitle">
      Congratulations! Your account has been successfully set up.
      You can now start creating and managing events.
    </p>

    <!-- What's Next -->
    <div class="next-box">
      <h4>What’s Next?</h4>

      <!-- Step 1 -->
      <div class="d-flex align-items-start mb-4">
        <div class="step-circle bg-success text-white me-3">1</div>
        <div>
          <div class="fw-semibold mb-1 fs-7">Profile Verification</div>
          <p class="text-muted mb-0">
            Our team will review your documents within 2-3 business days
          </p>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="d-flex align-items-start mb-4">
        <div class="step-circle bg-primary text-white me-3">2</div>
        <div>
          <div class="fw-semibold mb-1 fs-7">Create Your First Event</div>
          <p class="text-muted mb-0">
            Start listing events and selling tickets right away
          </p>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="d-flex align-items-start">
        <div class="step-circle bg-secondary text-white me-3">3</div>
        <div>
          <div class="fw-semibold mb-1 fs-7">Manage & Track</div>
          <p class="text-muted mb-0">
            Monitor ticket sales, attendees, and revenue from your dashboard
          </p>
        </div>
      </div>
      <!-- <ul>
        <li>
          <span class="dot"></span>
          <div>
            <strong>Create Your First Event</strong>
            <p>Start setting up your event details, ticket types, and pricing</p>
          </div>
        </li>

        <li>
          <span class="dot"></span>
          <div>
            <strong>Customize Your Profile</strong>
            <p>Add your logo, bio, and social media links</p>
          </div>
        </li>

        <li>
          <span class="dot"></span>
          <div>
            <strong>Explore Analytics</strong>
            <p>Track your sales, attendees, and revenue in real-time</p>
          </div>
        </li>
      </ul> -->
    </div>



    <div class="note-box text-start">
      <p class="mb-1 text-primary" style="text-transform: capitalize;"> Account Type: {{ organizer?.organizer_type }}
      </p>
      <p class="mb-1 text-primary">Registered Name: {{ organizer?.first_name }} {{ organizer?.last_name }} </p>
      <p class="mb-1 text-primary"> Email: {{ organizer?.email }}</p>
    </div>

    <!-- Button -->
    <button class="primary-btn mt-4">
      <a [href]="dashboardLoginUrl" target="_blank" class="_blank">Go to Dashboard →</a>
    </button>

    <!-- <p class="redirect-text">
      You will be automatically redirected in a few seconds
    </p> -->
  </div>
</div>

<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>
</div>